import { UUID } from 'symbols';
import { UserModel } from '../profile/symbols';

export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
  UAH = 'UAH',
}

export enum OperationTypeEnum {
  GENERAL = 'GENERAL',
  TRANSFER = 'TRANSFER',
}

export interface CurrencyPriceModel {
  ccy: CurrencyEnum;
  base_ccy: CurrencyEnum;
  buy: string;
  sale: string;
}

export interface FinanceScoreModel {
  id: UUID;
  name: string;
  totalSumOriginal: number;
  totalSumConverted: number;
  currency: CurrencyEnum;
  position: number;
  description: string;
}

export interface FinanceScoreExpectBackendModel {
  id?: UUID;
  name: string;
  currency: CurrencyEnum;
  description?: string;
}


export interface TransactionModel {
  id: UUID;
  type: OperationTypeEnum,
  scoreId: UUID;
  score: FinanceScoreModel;
  sum: number;
  createdAt: string;
  comment: string;
  currencyPrice: number;
  category: CategoryOfTransactionModel;
  categoryId: UUID;
  relatedTransactionId?: UUID;
  relatedTransaction?: TransactionModel;
  user: UserModel;
}

export interface TransactionExpectBackendModel {
  id?: UUID;
  type?: OperationTypeEnum,
  scoreId: UUID;
  toScoreId?: UUID;
  sum: number;
  convertedSum?: number;
  comment: string;
  categoryId?: UUID;
}


export interface CategoryOfTransactionModel {
  id: UUID;
  name: string;
  totalSum: number;
  showInStatistics: boolean;
}

export interface CategoryExpectBackendModel {
  id?: UUID;
  name: string;
  showInStatistics?: boolean;
}

export interface TransactionFilterModel {
  scopeIds: string[];
  categoryIds: string[];
  searchText: string;
  date: string;
}


export const scoreSymbol = {
  [CurrencyEnum.USD]: '$',
  [CurrencyEnum.EUR]: '€',
  [CurrencyEnum.UAH]: '₴'
};


export interface CategoryStatisticsModel {
  positive: CategoryOfTransactionModel[],
  negative: CategoryOfTransactionModel[],
}
